import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import HistoryDocument from './HistoryDocument';
import InfiniteScrollWithLoadMore from '../InfiniteScroll';
import s from './HistoryDocument.css';

const MAX_NUMBER_OF_AUTOLOADS = 1;

class HistoryDocuments extends React.Component {

  render () {
    const { deviceDocumentsPaging } = this.props;
    const hasMore =
      deviceDocumentsPaging.get('itemsPerPage') * deviceDocumentsPaging.get('currentPage') <
      deviceDocumentsPaging.get('itemsCount');

    const wrappedClasses = cx(
      s.listBordered,
      s.listBordered__large,
      s.listBordered__flat);
    const numberOlderItemsFetched = deviceDocumentsPaging.get('numberOlderItemsFetched');
    return (
      <InfiniteScrollWithLoadMore
        loadMore={this.props.getNextDocumentsPage}
        hasMore={hasMore}
        showLoadMore={numberOlderItemsFetched >= MAX_NUMBER_OF_AUTOLOADS}
        className={wrappedClasses}
      >
        {this.props.deviceDocuments.valueSeq().map(document =>
          <HistoryDocument 
            document={document}
            key={document.get('name')}
            serial={this.props.serial}
            deviceType={this.props.deviceType}
            deviceName={this.props.deviceName}
            newFilesDownloaded={this.props.newFilesDownloaded}
            getDeviceDocumentsList={this.props.getDeviceDocumentsList}/>
        )}
      </InfiniteScrollWithLoadMore>
    )
  }
}

HistoryDocuments.propTypes = {
  deviceDocuments: PropTypes.object.isRequired,  // eslint-disable-line react/forbid-prop-types
  deviceDocumentsPaging: PropTypes.object.isRequired,  // eslint-disable-line react/forbid-prop-types
  serial: PropTypes.string.isRequired,
  getNextDocumentsPage: PropTypes.func.isRequired,
  deviceType: PropTypes.string.isRequired,
  deviceName: PropTypes.string.isRequired,
  newFilesDownloaded: PropTypes.arrayOf(PropTypes.number).isRequired,
  getDeviceDocumentsList: PropTypes.func.isRequired,
};

const mapState = state => ({
  deviceDocuments: state.deviceDocuments,
  deviceDocumentsPaging: state.deviceDocumentsPaging,
});

export default compose(withStyles(s), connect(mapState, null))(HistoryDocuments);



// WEBPACK FOOTER //
// ./src/components/HistoryDocuments/HistoryDocuments.js